export const ROLE = Object.freeze({
    ADMIN: 'administrator',
    LANGUAGES: 'languages',
    MARKETING: 'marketing',
    TRANSLATOR: 'translator',
    USER: 'end-user',
})

export const ROLE_PRIVILEGE = Object.freeze({
    [ROLE.ADMIN]: 1,
    [ROLE.LANGUAGES]: 2,
    [ROLE.MARKETING]: 3,
    [ROLE.TRANSLATOR]: 4,
    [ROLE.USER]: 5,
})